import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { installDebugLog } from './utils/debugLog';

// Capture console + provisioning events into an in-app buffer BEFORE anything
// else runs, so the DebugOverlay can show them on locked kiosk tablets (no adb).
installDebugLog();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
